import styled from "styled-components";
import { useRef, useEffect } from "react";

import * as css from "styles/CssVariables.js";
import globalConstants from "constants/globalConstants";
import ButtonPrimary from "components/buttons/ButtonPrimary";
import InputWithLabel from "components/forms/InputWithLabel";
import InputText from "components/forms/InputText";

const PreviewWrap = styled.div`
  width: 100%;
  padding: 0 25px;
  box-sizing: border-box;

  flex: 1;

  display: flex;

  @media (max-width: ${globalConstants.switchTablet}) {
    padding: 0 8px;
  }
`;

const PreviewBorderWrap = styled.div`
  border-radius: ${css.BOX_RADIUS_SECONDARY};
  overflow: hidden;

  display: flex;

  flex: 1;
`;

const PreviewIframe = styled.iframe`
  width: 100%;
  height: 100%;
`;

export default ({ data }) => {
  const iframeRef = useRef(null);

  useEffect(() => {
    const iframe = iframeRef.current;
    if (iframe) {
      iframe.contentDocument.open();
      iframe.contentDocument.write(data.responderMessageData.html);
      iframe.contentDocument.close();
    }
  }, [data]);

  return (
    <PreviewWrap>
      <PreviewBorderWrap>
        <PreviewIframe ref={iframeRef} title="Message Preview"></PreviewIframe>
      </PreviewBorderWrap>
    </PreviewWrap>
  );
};
